"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BANNER_WRAPPER = exports.BANNER_QUIZ_TITLE = exports.BANNER_QUIZ_TEXT = exports.BANNER_IMAGE = exports.BANNER_CUSTOM_CONTENT = exports.BANNER_CONTENT_WRAPPER = exports.BANNER_CATALOGUE_TITLE = exports.BANNER_CATALOGUE_DATE_RANGE = exports.BANNER_ARROW = void 0;
const BANNER_WRAPPER = exports.BANNER_WRAPPER = 'BannerWrapper';
const BANNER_IMAGE = exports.BANNER_IMAGE = 'BannerImage';
const BANNER_ARROW = exports.BANNER_ARROW = 'BannerArrow';
const BANNER_CONTENT_WRAPPER = exports.BANNER_CONTENT_WRAPPER = 'BannerContentWrapper';
const BANNER_CATALOGUE_DATE_RANGE = exports.BANNER_CATALOGUE_DATE_RANGE = 'BannerCatalogueDateRange';
const BANNER_CATALOGUE_TITLE = exports.BANNER_CATALOGUE_TITLE = 'BannerCatalogueTitle';
const BANNER_QUIZ_TITLE = exports.BANNER_QUIZ_TITLE = 'BannerQuizTitle';
const BANNER_QUIZ_TEXT = exports.BANNER_QUIZ_TEXT = 'BannerQuizText';
const BANNER_CUSTOM_CONTENT = exports.BANNER_CUSTOM_CONTENT = 'BannerCustomContent';
